import { ProductOptionInterface } from '@qlevr/shared/interfaces';

export function hasSizeAndOrColor(options?: ProductOptionInterface[] | null) {
  if (!options) {
    return false;
  }

  return options.some((option) => option.name === 'size' || option.name === 'color');
}
